var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert-form',{attrs:{"alert-id":_vm.alertId,"details":_vm.details},on:{"submit":_vm.updateAlert,"close":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }